import { FullScreenLoader } from "@components/common/FullScreenLoader";
import SignatureContratPage from "@features/rh/contrats/components/SignatureContratPage";
import { useValidateSignatureToken } from "@features/rh/contrats/hooks/useValidateSignatureToken";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/auth/signature-contrat/$token")({
  component: SignatureContratRoute,
});

function SignatureContratRoute() {
  const { token } = Route.useParams();
  const { data, isLoading, error } = useValidateSignatureToken(token);

  if (isLoading) {
    return <FullScreenLoader message="Vérification du lien de signature..." />;
  }

  if (error || !data?.valid) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-base-200">
        <div className="card bg-base-100 shadow-xl max-w-md w-full mx-4">
          <div className="card-body text-center">
            <div className="text-6xl mb-4">⚠️</div>
            <h1 className="text-2xl font-bold mb-2">Lien invalide</h1>
            <p className="text-base-content/70 mb-4">
              Ce lien de signature est invalide, a expiré ou a déjà été utilisé.
            </p>
            <p className="text-sm text-base-content/50">
              Veuillez contacter le service RH pour obtenir un nouveau lien.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return <SignatureContratPage token={token} initialData={data} />;
}
